import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    
    {
        "Name": "Pidaparty S R K S Prasad",
        "Position": "Ph.D Scholar",
        "Batch": "July 2022",
        "AreasofResearch": "Microwave Sensing Devices",
        "GuideName": "Dr. Srujana Kagita",
        "GuideLink": "/dr-srujana-kagita",
        "Email": "ee22d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/PIDAPARTY.jpg"
    },

    {
        "Name": "R S Haripriya",
        "Position": "Ph.D Scholar (PMRF Scholar)",
        "Batch": "Jan 2022",
        "AreasofResearch": "VLSI Test and Verification",
        "GuideName": "Dr. Jaynarayan T Tudu",
        "GuideLink": "/dr-jaynarayan-t-tudu",
        "Email": "ee22d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/Haripriya_PMRF.JPG"
    },
    {
        "Name": "D Vijaya Lakshmi",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "VLSI Design",
        "GuideName": "Dr. Vikramkumar Pudi",
        "GuideLink": "/dr-vikramkumar-pudi",
        "Email": "ee20d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/Vijaya Lakshmi.JPG"
    },
    {
        "Name": "Arun Kumar Sivapuram",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Deep Learning for Computer Vision",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee19d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/arun.jpg"
    },
    {
        "Name": "Pinkesh Kumar Mishra",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2021",
        "AreasofResearch": "Nanoelectronics, Spintronics",
        "GuideName": "Dr Swapnil Bhuktare",
        "GuideLink": "/dr-swapnil-bhuktare",
        "Email": "ee21s503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/mishra.jpg"
    },
    {
        "Name": "P N S Bhargav",
        "Position": "Ph.D Scholar",
        "Batch": "July 2020",
        "AreasofResearch": "Semiconductor Devices",
        "GuideName": "Dr. Vijaya Kumar Gurugubelli",
        "GuideLink": "/dr-vijaya-kumar-gurugubelli",
        "Email": "ee20d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/bhargav.png"
    },
    {
        "Name": "Sreenivasulu Mamilla",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Sensors for Precision Agriculture (Semiconductor Devices)",
        "GuideName": "Dr. N N Murty",
        "GuideLink": "/dr-n-n-murty",
        "Email": "ee20d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/sreenivasulu.jpg"
    },
    {
        "Name": "Vineeta Gupta",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2021",
        "AreasofResearch": "VLSI and Embedded systems",
        "GuideName": "Dr. Prashanth Vooka",
        "GuideLink": "/dr-prashanth-vooka",
        "Email": "ee21s504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/vineetha.JPG"
    },
    {
        "Name": "Makireddy Poojitha",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2020",
        "AreasofResearch": "Sensors and signal conditioning circuits",
        "GuideName": "Dr. Prashanth Vooka",
        "GuideLink": "/dr-prashanth-vooka",
        "Email": "ee20s503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/Makireddy.jpg"
    },
    {
        "Name": "P Lakshmi Sarvaani",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2020",
        "AreasofResearch": "Digital VLSI Design",
        "GuideName": "Dr. Vikramkumar Pudi",
        "GuideLink": "/dr-vikramkumar-pudi",
        "Email": "ee20s504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/sarvani.jpg"
    },
        // {
        //     "Name": "Vikas Kumar",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "Jan 2021",
        //     "AreasofResearch": "Reinforcement Learning",
        //     "GuideName": "Dr. Ajin George Joseph",
        //     "GuideLink": "/dr-ajin-george-joseph",
        //     "Email": "cs21s001@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/vikas.png"
        // },
        // {
        //     "Name": "Aditi Palit",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jan 2021",
        //     "AreasofResearch": "Machine Learning Algorithms and Applications",
        //     "GuideName": "Dr. Kalidas Yeturu",
        //     "GuideLink": "/dr-kalidas-yeturu",
        //     "Email": "cs21d001@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/aditi.jpg"
        // },
        // {
        //     "Name": "Sai Prem Kumar Ayyagari",
        //     "Position": "Ph.D Scholar - External",
        //     "Batch": "Jul 2020",
        //     "AreasofResearch": "Machine Learning",
        //     "GuideName": "Dr. Y. Kalidas",
        //     "GuideLink": "/dr-kalidas-yeturu",
        //     "Email": "CS19D502@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS19D502%20Saiprem%20Kumar%20Ayyagari.jpeg"
        // },
        // {
        //     "Name": "Shriram Shridhar Shanbhag",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "Jul 2020",
        //     "AreasofResearch": "Software Engineering",
        //     "GuideName": "Dr. Sridhar Chimalakonda",
        //     "GuideLink": "/dr-sridhar-chimalakonda",
        //     "Email": "CS20S503@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS20S503%20Shriram%20Shridhar%20Shanbhag.JPG"
        // },
        //  {
        //     "Name": "Akhila Sri Manasa",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jan 2020",
        //     "AreasofResearch": "Software Engineering",
        //     "GuideName": "Dr. Sridhar Chimalakonda",
        //     "GuideLink": "/dr-sridhar-chimalakonda",
        //     "Email": "cs19d504@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/manasar.jpg"
        // },
        // {
        //     "Name": "Tharakeswara Raju B",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jul 2019",
        //     "AreasofResearch": "Wireless Networks",
        //     "GuideName": "Prof. Venkata Ramana Badarla",
        //     "GuideLink": "/dr-venkata-ramana-badarla",
        //     "Email": "CS19D503@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS19D503_Tharakeswara Raju.jpg"
        // },
        // {
        //     "Name": "Naresh Babu Kakarla",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2019",
        //     "AreasofResearch": "Computer Networks",
        //     "GuideName": "Dr. V. Mahendran",
        //     "GuideLink": "/dr-v-mahendran",
        //     "Email": "cs19d501@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/NareshBabuKakarla.JPG"
        // },
        // {
        //     "Name": "A Eashaan Rao",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2019",
        //     "AreasofResearch": "Software Engineering",
        //     "GuideName": "Dr. Sridhar Chimalakonda",
        //     "GuideLink": "/dr-sridhar-chimalakonda",
        //     "Email": "cs19s501@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/eeshan.jpeg"
        // },
        // {
        //     "Name": "G V Sumukha Bharadwaj",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2019",
        //     "AreasofResearch": "Computational Complexity",
        //     "GuideName": "Dr. S Raja",
        //     "GuideLink": "/dr-s-raja",
        //     "Email": "cs19s502@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/GVSumukhaBharadwaj.jpg"
        // },
        // {
        //     "Name": "Mithinti Srikanth",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Algorithm Engineering",
        //     "GuideName": "Dr. G. Ramakrishna",
        //     "GuideLink": "/dr-g-ramakrishna",
        //     "Email": "cs18d501@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18D501_MITHINTISRIKANTH.jpg"
        // },
        // {
        //     "Name": "Arnab Bhadra",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Machine Learning Algorithms & Applications",
        //     "GuideName": "Dr. Kalidas Yeturu",
        //     "GuideLink": "/dr-kalidas-yeturu",
        //     "Email": "cs18s501@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S501_ArnabBhadra.jpg"
        // },
        // {
        //     "Name": "Chirayu Anant Haryan",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Algorithm Engineering",
        //     "GuideName": "Dr. G. Ramakrishna",
        //     "GuideLink": "/dr-g-ramakrishna",
        //     "Email": "cs18s503@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S503_ChirayuAnantHaryan.jpg"
        // },
        // {
        //     "Name": "K Prashanth",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Machine Learning Algorithms and Applications",
        //     "GuideName": "Dr. Kalidas Yeturu",
        //     "GuideLink": "/dr-kalidas-yeturu",
        //     "Email": "cs18s504@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS18S504_KomuravelliPrashanth.jpg"
        // },
        // {
        //     "Name": "Rohit Gupta",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Computer Networks",
        //     "GuideName": "Dr. V. Mahendran",
        //     "GuideLink": "/dr-v-mahendran",
        //     "Email": "cs18s505@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S505_RohitGupta.jpg"
        // },
        // {
        //     "Name": "Suri Bhasker Sri Harsha",
        //     "Position": "M.S (Research) Scholar",
        //     "Batch": "July 2018",
        //     "AreasofResearch": "Machine Learning Algorithms and applications",
        //     "GuideName": "Dr. Kalidas Yeturu",
        //     "GuideLink": "/dr-kalidas-yeturu",
        //     "Email": "CS18S506@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S506_BhaskerSriHarsha.jpg"
        // },
        // {
        //     "Name": "Vamshi Vijay Krishna J",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jan 2018",
        //     "AreasofResearch": "Computer Networks",
        //     "GuideName": "Dr. V. Mahendran",
        //     "GuideLink": "/dr-v-mahendran",
        //     "Email": "cs18d002@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/vamshikrishna.png"
        // },
   
    {
        "Name": "Nani Medicherla",
        "Position": "Ph.D Scholar",
        "Batch": "July 2021",
        "AreasofResearch": "MetaMaterial inspired RF structures for HPM and Tera Hertz devices",
        "GuideName": "Prof. M. V. Kartikeyan",
        "GuideLink": "/dr-m-v-kartikeyan",
        "Email": "ee21d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/nani.jpg"
    },
    {
        "Name": "Shailendra Singh",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2021",
        "AreasofResearch": "Metasurface Antennas",
        "GuideName": "Prof. M. V. Kartikeyan",
        "GuideLink": "/dr-m-v-kartikeyan",
        "Email": "ee21d006@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/SHAILENDRA.jpg"
    },
    {
        "Name": "Harikrishna S Thota",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2021",
        "AreasofResearch": "Robotics, Smart Manufacturing, Control",
        "GuideName": "Dr. P.S.SaiKrishna",
        "GuideLink": "/dr-sai-krishna",
        "Email": "ee21d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/hari.jpg"
    },
    {
        "Name": "Bandaru Meenakshi Sravani",
        "Position": "Ph.D Scholar",
        "Batch": "July 2020",
        "AreasofResearch": "Spintronics",
        "GuideName": "Dr. Swapnil Bhuktare",
        "GuideLink": "/dr-swapnil-bhuktare",
        "Email": "ee20d503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/meenakshi.jpg"
    },
    {
        "Name": "Goutam Ghosh",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2020",
        "AreasofResearch": "Power Electronics and Drives",
        "GuideName": "Dr. Viju Nair. R",
        "GuideLink": "/dr-viju-nair-r",
        "Email": "ee20s502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/goutam.jpg"
    },
    {
        "Name": "P. Raghavendra Rao",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Opinion Dynamics in Multiagent systems",
        "GuideName": "Dr. Pooja Vyavahare",
        "GuideLink": "/dr-pooja-vyavahare",
        "Email": "ee20d002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/Raghu.jpg"
    },
    {
        "Name": "Ravi Vaishnavi",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "3D reconstruction, Computer Vision, Deep learning",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee19d504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/vaishnavi.jpg"
    },
    {
        "Name": "S.Sree Rama Vamsidhar",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Signal Processing with deep learning techniques",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee19d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/Vamsi%20photo.jpg"
    },
    
    {
        "Name": "M.Hareesh Kumar Reddy",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Smart Grid Technology",
        "GuideName": "Dr. Vignesh V",
        "GuideLink": "/dr-vignesh-v",
        "Email": "ee19d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/hareeshee.jpg"
    },
    {
        "Name": "Konduru Lakshmi Bhanu Prakash Reddy",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Secure Communication of Data for Real-Time Monitoring Systems, Digital Circuits Design",
        "GuideName": "Dr. Vikramkumar Pudi",
        "GuideLink": "/dr-vikramkumar-pudi",
        "Email": "ee19d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/bhanu.jpg"
    },
    {
        "Name": "Rama Krishna Muni",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Performance analysis of Wireless Networks, Markov Decision Processes and Stochastic Games",
        "GuideName": "Dr. K P Naveen",
        "GuideLink": "/dr-k-p-naveen",
        "Email": "ee19d503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/ram1.jpg"
    },
    {
        "Name": "Aluru Shilpa",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Electrical Characterization of 4H-Siliconcarbide Interface",
        "GuideName": "Dr. N. N. Murty",
        "GuideLink": "/dr-n-n-murty",
        "Email": "ee19s501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/shilpa.jpg"
    },
    {
        "Name": "Somalatha Uppalapati",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2019",
        "AreasofResearch": "Physical layer security",
        "GuideName": "Dr. Parthajit Mohapatra",
        "GuideLink": "/dr-parthajit-mohapatra",
        "Email": "ee19d002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/dummy.jpg"
    },
    {
        "Name": "A Sai Kartheek Bandi",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2019",
        "AreasofResearch": "Transducers applications and signal conditioning",
        "GuideName": "Dr. Prashanth Vooka",
        "GuideLink": "/dr-prashanth-vooka",
        "Email": "ee19d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/ee19d001_ASaiKartheekBandi.jpg"
    },
    {
        "Name": "N.Santhan Kumar Reddy",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2019",
        "AreasofResearch": "Digital Signal Processing",
        "GuideName": "Dr. Subrahmanyam Gorthi",
        "GuideLink": "/dr-subrahmanyam-gorthi",
        "Email": "ee19s001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/SanthanKumar.jpeg"
    },
    {
        "Name": "Dinsha Vinod",
        "Position": "Ph.D Scholar",
        "Batch": "July 2018",
        "AreasofResearch": "Model predictive control",
        "GuideName": "Dr. P.S.SaiKrishna",
        "GuideLink": "/dr-sai-krishna",
        "Email": "ee18d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/ee/dinsha.JPG"
    },
    {
        "Name": "M Sushma",
        "Position": "Ph.D Scholar",
        "Batch": "July 2018",
        "AreasofResearch": "Performance Analysis of Wireless Networks",
        "GuideName": "Dr.K.P.Naveen",
        "GuideLink": "/dr-k-p-naveen",
        "Email": "EE18D502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/EE18D502_M_SUSHMA.JPG"
    },
    {
        "Name": "Krishna Sumanth Vengala",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2018",
        "AreasofResearch": "Image processing and Machine learning",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee18s501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/EE18S501_krishnasumanth.jpg"
    },
    {
        "Name": "Sameer Ranjan Sahu",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2018",
        "AreasofResearch": "Signal processing",
        "GuideName": "Dr. Subrahmanyam Gorthi",
        "GuideLink": "/dr-subrahmanyam-gorthi",
        "Email": "ee18s502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/SameerRanjanSahu.jpg"
    },
    {
        "Name": "C Sindhura",
        "Position": "Ph.D Scholar",
        "Batch": "July 2018",
        "AreasofResearch": "Medical Image Processing",
        "GuideName": "Dr. Subrahmanyam Gorthi",
        "GuideLink": "/dr-subrahmanyam-gorthi",
        "Email": "EE18D504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/EE18D504_C Sindhura.jpg"
    },
    {
        "Name": "Bhalekar Vaibhav Bhausaheb",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2017",
        "AreasofResearch": "Control Systems",
        "GuideName": "Dr. PS Sai Krishna",
        "GuideLink": "/dr-sai-krishna",
        "Email": "ee17ms001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/vaibha.jpg"
    },
    {
        "Name": "Dasari Mohana Murali",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2018",
        "AreasofResearch": "Computer Vision & Machine Learning (Visual Tracking)",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee18d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/murali.jpg"
    },
    {
        "Name": "Jagadeesh Kumar M",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2017",
        "AreasofResearch": "Image Processing, Computer Vision & Machine Learning",
        "GuideName": "Dr. Subrahmanyam Gorthi and Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-subrahmanyam-gorthi and /dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee17ms003@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/jagdeeshkumar.jpg"
    },
    {
        "Name": "P Naveen",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2017",
        "AreasofResearch": "Computer Vision & Machine Learning (Visual Tracking)",
        "GuideName": "Dr. Rama Krishna Sai Gorthi",
        "GuideLink": "/dr-rama-krishna-sai-subrahmanyam-gorthi",
        "Email": "ee17ms004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/naveen.jpg"
    },
    {
        "Name": "S Harsha",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2018",
        "AreasofResearch": "Control systems",
        "GuideName": "Dr. P S SaiKrishna",
        "GuideLink": "/dr-sai-krishna",
        "Email": "ee18s001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/dummy.jpg"
    },
    {
        "Name": "Spoorthi GE",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2017",
        "AreasofResearch": "Image Processing",
        "GuideName": "Dr. Subrahmanyam Gorthi",
        "GuideLink": "/dr-subrahmanyam-gorthi",
        "Email": "ee17ms005@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/spoorthi.jpg"
    },
    {
        "Name": "V.Lakshmi Vineela",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2018",
        "AreasofResearch": "Microelectronics",
        "GuideName": "Dr. N N Murty",
        "GuideLink": "/dr-n-n-murty",
        "Email": "ee18s002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/vineela.jpg"
    }




    



]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Electrical Engineering" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Electrical Engineering</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main